const Staff = {

    // FIELDS
    "staff_name": "Staff Name",
    "father_name": "Father Name",
    "date_of_birth": "Date of Birth",
    "staff_code": "Staff Code",
    "gender": "Gender",
    "email": "Email",
    "phone": "Phone Number",
    "login": "Email",
    "password": "Password",
    "allow_signin_user": "Allow Sign In User",
    "role_id": "Role",
    "department_id": "Department",
    "designation_id": "Designation",
    "search": "Search",

    // PAGE HEADER
    "staff": "Staff",

    // ERROR
    "error_staff_name": "Enter Staff Name",
    "error_father_name": "Enter Father Name",
    "error_date_of_birth": "Select Date of Birth",
    "error_staff_code": "Enter Staff Code",
    "error_gender": "Select Gender",
    "error_email": "Enter Email",
    "error_phone": "Enter Phone Number",
    "error_login": "Enter Login ID",
    "error_password": "Enter Password",
    "error_allow_signin_user": "Select Allow Sign In User",
    "error_role_id": "Select Role",
    "error_department_id": "Select Department",
    "error_designation_id": "Select Designation",

    // TABLE HEADER
    "table_name": "STAFF NAME",
    "table_father": "FATHER NAME",
    "table_code": "STAFF CODE",
    "table_gender": "GENDER",
    "table_email": "EMAIL",
    "table_phone": "PHONE NUMBER",
    "table_department": "DEPARTMENT",
    "table_designation": "DESIGNATION",

}

export default Staff;

